import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import Head from 'next/head';

import { ContextProvider } from '@/context/index';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../styles/globals.css';

function MyApp({ Component, pageProps }) {
  const router = useRouter();

  useEffect(() => {
    if (window?.history?.scrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  // Use the full path as key to force remount on route changes
  const pageKey = router.asPath.split('?')[0] || router.pathname;

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>

      <ContextProvider>
        <ParallaxProvider key={pageKey}>
          <Component {...pageProps} key={pageKey} />
        </ParallaxProvider>
      </ContextProvider>
    </>
  );
}

export default MyApp;
